import { getData, getDataConcurrent } from '@/components/report/service';
import RouteEntity from '@/Entity/RouteEntity';
import GenerateCondit, { Bound } from '@/models/GenerateCondit';
import { CALCWEIGHT, GOODSVOLUME, GOODSWEIGHT, PIECE, TICKET } from '@/models/GenerateCondit/Interrelated';
import PublicAggCaculate from '@/models/GenerateCondit/PublicAggCaculate';
import { crudRequest } from '@/services/api';
import { calculateDiff, groupBys, groupBysAggreObject } from '@/utils/columnSearch';
import { computeWeightNotAbs } from '@/utils/query';
import moment from 'moment';
import {
  DesSiteDetailQuery, DesSiteDetailQuerys, DesSiteDetailQueryss
} from '../Tables/PlanDepartureTable/Sql';
import lodash from "lodash"

const params = {}
export default {
  namespace: 'stockweightviewmodals',
  state: {
    modalsVisible: false,
    modalsTitle: '',
    modalsNextSite: '',

    // 产品类型饼图
    productList: [],
    // 是否优势产品
    superiorityProductList: [],
    // 必走货
    mustSenData: [],
    // 发往目的货量
    desSiteToNextSiteList: [],

    loadExportDataList: [],
    unloadExportDataList: [],
    unloadProductData: [],
    loadProductData: [],
  },

  effects: {
    // 重置
    *setReset(_, { put }) {
      yield put({
        type: 'update',
        payload: {
          modalsVisible: false,
        },
      });
    },
    *getSelect({ payload }, { put }) {
      yield put({
        type: 'update',
        payload: { ...payload },
      });
      crudRequest('/api/route/centerweightview/stock_detail')
      if (payload.sotckDayCount === 3)
        yield put({ type: 'getDataSource' });
      else
        yield put({ type: 'getDataSources' });
      // crudRequest('/api/route/centerweightview/stock_MustSendGoods')
      // yield put({ type: 'getMustSendGoods' });
    },
    // 优势产品
    *getDepartureProducts({ payload }, { put }) {
      let { stockData } = payload
      let groupData = groupBys(stockData, 'productType')
      let productList = groupBysAggreObject(groupData, ['calcWeight'])
      productList = productList.map(item => {
        if (item.calcWeight > 0.01)
          return ({ name: item.productType, value: computeWeightNotAbs(item.calcWeight) })
      })
      yield put({ type: 'update', payload: { productList } })
    },
    // 库存优势(非)产品
    *getDeparturesuPeriorityLists({ payload }, { put, call, select }) {
      const { stockData } = payload
      const superiorityProduct = { '是': '优势业务', '否': '非优势业务' }
      let groupData = groupBys(stockData, 'superiorityProduct')
      let superiorityProductList = groupBysAggreObject(groupData, ['calcWeight'])
      superiorityProductList = superiorityProductList.map(item => {
        if (item.calcWeight > 0.01)
          return ({
            name: superiorityProduct[item.superiorityProduct],
            value: computeWeightNotAbs(item.calcWeight)
          })
      })
      yield put({ type: 'update', payload: { superiorityProductList } })
    },
    /** 目的分拨列表 */
    *getDetailDataLists({ payload }, { put }) {
      let { stockData } = payload
      let groupData = groupBys(stockData, 'destinationCenter')
      let desSiteToNextSiteList = groupBysAggreObject(
        groupData,
        ['calcWeight', 'goodsWeight', 'goodsVolume', 'ticket', 'piece'],
      )
      let acount = 0  // 获取重量总和
      desSiteToNextSiteList.forEach(m => { acount += m.calcWeight })
      desSiteToNextSiteList = desSiteToNextSiteList.sort((a, b) => {
        return (b.calcWeight - a.calcWeight)
      }).map(item => ({
        ...item, proportion: (item.calcWeight / Math.abs(acount) * 100).toFixed(1)
      }))
      yield put({ type: 'update', payload: { desSiteToNextSiteList } })
    },

    *getDataSource(_, { put, call, select }) {
      let { centerFilter, startDate, endDate } = yield select(({ centerWeightView }) => {
        return {
          centerFilter: centerWeightView.centerFilter,
          startDate: moment(centerWeightView.dateRange[0]).format(centerWeightView.defualtDateFormat),
          endDate: moment(centerWeightView.dateRange[1]).format(centerWeightView.defualtDateFormat),
        }
      });
      const { modalsNextSite: nextSite, sotckDayCount } = yield select(({ stockweightviewmodals }) => stockweightviewmodals)
      const params = { scanSite: centerFilter, nextSite, startDate, endDate, sotckDayCount }
      const { unload } = DesSiteDetailQuery(params)
      let unloadProductData = yield call(getData, unload)
      // 去重
      // unloadProductData = lodash.uniqWith(unloadProductData, (f, l) => f.waybillNo === l.waybillNo)
      // 卸车件数至少大于0的
      unloadProductData = unloadProductData.filter(m => m.piece)
      // 根据卸车单号查装车数据，需要卸车单号存在
      const waybillNos = unloadProductData.map(m => m.waybillNo)
      const { load } = DesSiteDetailQuery({ ...params, waybillNos })
      let loadProductData = yield call(getData, load)
      let sum = 0
      unloadProductData.forEach(m => {
        sum += m.calcWeight
      })

      let sums = 0
      loadProductData.forEach(m => {
        sums += m.calcWeight
      })

      const stockData = calculateDiff(
        unloadProductData,
        loadProductData,
        ['calcWeight', 'goodsWeight', 'goodsVolume', 'ticket', 'piece'],
        (unItem, loadItem) => {
          return (
            unItem.waybillNo === loadItem.waybillNo &&
            unItem.destinationCenter === loadItem.destinationCenter &&
            unItem.productType === loadItem.productType &&
            unItem.mustGoGoods === loadItem.mustGoGoods &&
            unItem.superiorityProduct === loadItem.superiorityProduct &&
            unItem.nextSite === loadItem.planNextSite
          )
        }
        /// 如果数据正常只需要判断件数存在的即可
      ).filter(m => {
        const isReserve = m.piece !== 0
        if (isReserve && m.ticket === 0) {
          m.ticket = 1
        }
        return isReserve
      })

      const ticketWay = (item, tickets) => {
        if (item.ticket === 0 && item.piece !== 0) {
          item.ticket = tickets
        }
        return item
      }
      unloadProductData = unloadProductData.map((item) => ticketWay(item, 1))
      loadProductData = loadProductData.map((item) => ticketWay(item, -1))

      const payload = { stockData: stockData || [] }
      yield put({
        type: 'update', payload: {
          unloadProductData: unloadProductData,
          loadProductData: loadProductData,
          stockData
        }
      })

      // 下一站
      yield put({ type: 'getDetailDataLists', payload })
      // 产品类型
      yield put({ type: 'getDepartureProducts', payload });
      // 时效类型
      yield put({ type: 'getDeparturesuPeriorityLists', payload });
    },

    *getDataSources(_, { put, call, select }) {
      let { centerFilter, startDate, endDate } = yield select(({ centerWeightView }) => {
        return {
          centerFilter: centerWeightView.centerFilter,
          startDate: moment(centerWeightView.dateRange[0]).format(centerWeightView.defualtDateFormat),
          endDate: moment(centerWeightView.dateRange[1]).format(centerWeightView.defualtDateFormat),
        }
      });
      const { modalsNextSite: nextSite, sotckDayCount } = yield select(({ stockweightviewmodals }) => stockweightviewmodals)
      const params = { scanSite: centerFilter, nextSite, startDate, endDate, sotckDayCount: -7 }
      const { unload, load } = DesSiteDetailQuerys(params)
      // console.log('unload', unload)
      let [unloadProductData, loadProductData] = yield call(getDataConcurrent, [unload, load])
      // 去重
      // unloadProductData = lodash.uniqWith(unloadProductData, (f, l) => f.waybillNo === l.waybillNo)
      // 卸车件数至少大于0的
      // unloadProductData = unloadProductData.filter(m => m.piece)
      // // 根据卸车单号查装车数据，需要卸车单号存在
      // const waybillNos = unloadProductData.map(m => m.waybillNo)
      // // console.log('旧卸车主单', waybillNos)
      // const { load } = DesSiteDetailQuery({ ...params, waybillNos })
      // let loadProductData = yield call(getData, load)
      let sum = 0
      unloadProductData.forEach(m => {
        sum += m.calcWeight
      })

      let sums = 0
      loadProductData.forEach(m => {
        sums += m.calcWeight
      })

      const stockData = calculateDiff(
        unloadProductData,
        loadProductData,
        ['calcWeight', 'goodsWeight', 'goodsVolume', 'ticket', 'piece'],
        (unItem, loadItem) => {
          return (
            unItem.waybillNo === loadItem.waybillNo &&
            unItem.destinationCenter === loadItem.destinationCenter &&
            unItem.productType === loadItem.productType &&
            unItem.mustGoGoods === loadItem.mustGoGoods &&
            unItem.superiorityProduct === loadItem.superiorityProduct &&
            unItem.nextSite === loadItem.planNextSite
          )
        }
        /// 如果数据正常只需要判断件数存在的即可
      ).filter(m => {
        const isReserve = m.piece !== 0
        if (isReserve && m.ticket === 0) {
          m.ticket = 1
        }
        return isReserve
      })

      const ticketWay = (item, tickets) => {
        if (item.ticket === 0 && item.piece !== 0) {
          item.ticket = tickets
        }
        return item
      }
      unloadProductData = unloadProductData.map((item) => ticketWay(item, 1))
      loadProductData = loadProductData.map((item) => ticketWay(item, -1))

      const payload = { stockData: stockData || [] }
      yield put({
        type: 'update', payload: {
          unloadProductData: unloadProductData,
          loadProductData: loadProductData,
          stockData
        }
      })

      // 下一站
      yield put({ type: 'getDetailDataLists', payload })
      // 产品类型
      yield put({ type: 'getDepartureProducts', payload });
      // 时效类型
      yield put({ type: 'getDeparturesuPeriorityLists', payload });
    },

    *getDataSourcess(_, { put, call, select }) {
      let { centerFilter, startDate, endDate } = yield select(({ centerWeightView }) => {
        return {
          centerFilter: centerWeightView.centerFilter,
          startDate: moment(centerWeightView.dateRange[0]).format(centerWeightView.defualtDateFormat),
          endDate: moment(centerWeightView.dateRange[1]).format(centerWeightView.defualtDateFormat),
        }
      });
      const { modalsNextSite: nextSite, sotckDayCount } = yield select(({ stockweightviewmodals }) => stockweightviewmodals)
      const params = { scanSite: centerFilter, nextSite, startDate, endDate }
      // 查询条件
      const unloadParamArr = []
      const loadParamArr = []
      const sliceDay = 1
      for (let i = 0; i <= sotckDayCount; i += sliceDay) {
        const endDiff = (i + sliceDay) - sotckDayCount - 1
        let timeDiff = endDiff > 0 ? endDiff - (i + sliceDay) : -(i + sliceDay)
        const { unload } = DesSiteDetailQueryss({
          ...params,
          startDate: moment(params.endDate).add(timeDiff, 'days'),
          endDate: moment(params.endDate).add(-i, 'days')
        })
        unloadParamArr.push(unload)
      }
      const unloadResult = yield call(getDataConcurrent, unloadParamArr)

      let waybillNos = []
      let unloadProductData = []
      for (let i = 0; i < unloadResult.length; i++) {
        let waybillNoTemp = []
        unloadResult[i].forEach(item => {
          // 卸车件数至少大于0的
          if (item.piece) {
            unloadProductData.push(item)
            waybillNos.push(item.waybillNo)
            waybillNoTemp.push(item.waybillNo)
          }
        })

        const days = i * sliceDay
        const endDiff = (days + sliceDay) - sotckDayCount - 1
        let timeDiff = endDiff > 0 ? endDiff - (days + sliceDay) : -(days + sliceDay)
        const { load } = DesSiteDetailQueryss({
          ...params,
          waybillNos: waybillNoTemp,
          startDate: moment(params.endDate).add(timeDiff, 'days'),
          endDate: moment(params.endDate).add(-i, 'days')
        })
        loadParamArr.push(load)
        waybillNos = lodash.uniqWith(waybillNos, (f, l) => f === l)
      }

      // 根据卸车单号查装车数据，需要卸车单号存在
      let loadResult = yield call(getDataConcurrent, loadParamArr)
      let loadProductData = []
      for (let i = 0; i < loadResult.length; i++) {
        loadResult[i].forEach(item => {
          loadProductData.push(item)
        })
      }
      let sum = 0
      unloadProductData.forEach(m => {
        sum += m.calcWeight
      })
      let sums = 0
      loadProductData.forEach(m => {
        sums += m.calcWeight
      })

      const stockData = calculateDiff(
        unloadProductData,
        loadProductData,
        ['calcWeight', 'goodsWeight', 'goodsVolume', 'ticket', 'piece'],
        (unItem, loadItem) => {
          return (
            unItem.waybillNo === loadItem.waybillNo &&
            unItem.destinationCenter === loadItem.destinationCenter &&
            unItem.productType === loadItem.productType &&
            unItem.mustGoGoods === loadItem.mustGoGoods &&
            unItem.superiorityProduct === loadItem.superiorityProduct &&
            unItem.nextSite === loadItem.planNextSite
          )
        }
        /// 如果数据正常只需要判断件数存在的即可
      ).filter(m => {
        const isReserve = m.piece !== 0
        if (isReserve && m.ticket === 0) {
          m.ticket = 1
        }
        return isReserve
      })

      const ticketWay = (item, tickets) => {
        if (item.ticket === 0 && item.piece !== 0) {
          item.ticket = tickets
        }
        return item
      }
      unloadProductData = unloadProductData.map((item) => ticketWay(item, 1))
      loadProductData = loadProductData.map((item) => ticketWay(item, -1))
      const payload = { stockData: stockData || [] }
      yield put({
        type: 'update', payload: {
          unloadProductData: unloadProductData,
          loadProductData: loadProductData,
          stockData
        }
      })

      // 下一站
      yield put({ type: 'getDetailDataLists', payload })
      // 产品类型
      yield put({ type: 'getDepartureProducts', payload });
      // 时效类型
      yield put({ type: 'getDeparturesuPeriorityLists', payload });
    },

    // 必走货
    *getMustSendGoods({ payload }, { put, call, select }) {
      let { centerFilter, startDate, endDate } = yield select(({ centerWeightView }) => {
        return {
          centerFilter: centerWeightView.centerFilter,
          startDate: moment(centerWeightView.dateRange[0]).format(centerWeightView.defualtDateFormat),
          endDate: moment(centerWeightView.dateRange[1]).format(centerWeightView.defualtDateFormat),
        }
      });
      const { modalsNextSite: nextSite } = yield select(({ stockweightviewmodals }) => stockweightviewmodals)
      const groupByField = ['waybillNo', 'destinationCenter', 'nextSite']
      const aggreField = [CALCWEIGHT, PIECE, TICKET, GOODSWEIGHT, GOODSVOLUME]

      const startDate_stock = moment(startDate).add(-6, 'days').format('YYYY-MM-DD HH:mm:ss')
      const end_stock = moment(endDate).add(-3, 'days').format('YYYY-MM-DD HH:mm:ss')
      const newGenrate = {
        dataSource: 'actual_load_unload_result',
        dimensions: groupByField,
        aggregators: aggreField,
        startDate: startDate_stock,
        endDate: end_stock
      }

      //卸车
      const gc = new GenerateCondit(newGenrate)
      const unloadEntity = new RouteEntity({
        scanType: '分拨卸车',
        scanSite: centerFilter,
        nextSite: nextSite,
        isDestinationCenter: '否'
      })
      const unloadQuery = gc.converCondit(unloadEntity)
      const unload = yield getData(unloadQuery)
      const unload_waybillNos = unload.map(m => m.waybillNo)

      //装车
      const groupByFieldLoad = groupByField.filter(m => m !== 'nextSite')
      groupByFieldLoad.push('planNextSite')
      const gcLoad = new GenerateCondit({
        ...newGenrate,
        dimensions: groupByFieldLoad,
      })
      const loadEntity = new RouteEntity({
        scanType: '分拨装车',
        scanSite: centerFilter,
        planNextSite: nextSite,
        waybillNo: unload_waybillNos
      })
      const bound = new Bound(
        'unloadAggregateTime',
        moment(startDate_stock).format('YYYY-MM-DD'),
        moment(endDate).add(-3, 'days').format('YYYY-MM-DD'),
      )
      gcLoad.endDateAdd(3)
      gcLoad.pushBoundFilters(bound)
      const loadQuery = gcLoad.converCondit(loadEntity)

      const load = yield getData(loadQuery)
      //调用公共库存逻辑
      const pubTool = new PublicAggCaculate(gcLoad)
      const stockDataSource = yield pubTool
        .calculateSotckData(
          unload, load, groupByField,
          aggreField.map((aggf) => aggf.fieldName),
          (item) => item.piece > 0
        )
      yield put({
        type: 'update',
        payload: { mustSenData: stockDataSource }
      })
    },
  },

  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  }
}

